import React from 'react';
import { useState, useEffect } from 'react';
import './classes/Mentor.css';
import { configData } from "../config";
import { liveCopyOrPlaceholder } from './liveImageFallback';

// conference: the block on a conference page, which the live theme heads "Speakers: Varies By
// Year" (block.tpl.php) instead of "Mentors". onLoaded(count) is told how many mentors there are.
const Mentor = ({page, conference, onLoaded}) => {
  const app_url = configData.APP_URL;
  const [content, setContent] = useState([]);

useEffect(() => {
//   setContent([
//   {
//     name: 'Larry Lundy',
//     img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw',
//     bio: ['Sport & Athlete Branding Specialist'],
//     link: "#"
//   },
//   {
//     name: 'Dr Lynn Lashbrook',
//     img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw',
//     bio: ['SMWW President & Founder', 'Certified NFL Agent', 'Former NCAA Athletic Director'],
//     link: "#"
//   }
// ]);
if(page?.nid) {
getmentors(page.nid);
}
}, [page]);
 const getmentors = async (nid) => {
    try {
     
      const postData = {
           nid: nid,
           
          };
          try {
            const response = await fetch(app_url + 'coursepages/getmentors', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
              setContent(data.data.result);
              onLoaded && onLoaded(data.data.result.length);
            }
          } catch (err) {
             
        }
      
      
    } catch (err) {
      console.error(err);
    }
};
  // A picture that is missing on the server: the live site's copy of it, else the "not available"
  // image instead of a broken one (a broken picture also stretches to the full height of the page)
  const placeholderImg = configData.DRUPAL_DOMAIN_URL + '/sites/person_images/notavailable.jpg';
  const showPlaceholder = liveCopyOrPlaceholder(placeholderImg);
  // As on the live site, the block is left out when there is nothing to list
  if (!content.length) return null;
  return (
    <div className="course-mentor-card">
      {conference ? (
        <h2 className="mentor-header">Speakers:<br /><span className="mentor-header__sub">Varies By Year</span></h2>
      ) : (
        <h2 className="mentor-header">Mentors</h2>
      )}
      <ul className="mentor-list">
        {content.map((mentor, idx) => (
          <li key={idx} className="mentor-item">
            <img src={mentor.img} alt={mentor.name} className="mentor-avatar" onError={showPlaceholder} />
            <a href={mentor.link} className="mentor-name-link">
              {mentor.name}
            </a>
             <span 
                dangerouslySetInnerHTML={{
                    __html:mentor.bio
                }}
            />
            
          </li>
        ))}
      </ul>
    </div>
  );
};
export default Mentor;